import React from 'react';
import { Table, Empty } from 'antd';
import ProductoTable from './ProductoTable';

export default class AlmacenTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <Table
                className={'logistica-table-kardex-almacen'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={this.props.dataSource}
                rowKey={record => record.id}
                onExpand={async (expanded, record) => {
                    await this.props.onSearchKardexProducto(expanded, record);
                }}
                expandedRowRender={(record) => {
                    return (
                        <div style={{ margin: '10px 0px' }}>
                            {
                                <ProductoTable
                                    dataSource={record.productos}
                                    onSearchKardexMovimiento={this.props.onSearchKardexMovimiento}
                                />
                            }
                        </div>
                    )
                }}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='No se encontraron datos.'
                    />
                }}
                columns={[
                    {
                        title: 'Almacén',
                        dataIndex: 'nombre',
                        key: 'nombre'
                    }
                ]}
            />
        );
    }
}